export const environment = {
  production: true,
  apiurl: 'https://api-trustii-v2.azurewebsites.net/api',
  apiV2url: 'https://api-trustii-v2.azurewebsites.net/api',
  reCaptchaKey: '6LcFFvQUAAAAAEyz0AwkrSwLrDnRXmF86K4BMUZb'
};
